export default __webpack_public_path__ + "static/media/manikant.e09bc224.jpeg";